import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpHandlerService } from './http-handler.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(
    private readonly _httpHandlerService: HttpHandlerService
  ) { }

  public userSubject$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public userSelectedTenant$: BehaviorSubject<any> = new BehaviorSubject<any>('');

  setUser(value: any) {
    this.userSubject$.next(value);
  }

  changeSelectedTenant(selectedOrg: any) {
    this.userSelectedTenant$.next(selectedOrg)
  }

  public uploadFile(formData: any, entityTypeEnum = "MSSP", entityId?: string): Observable<any> {
    let url = `upload?entityTypeEnum=${entityTypeEnum}`;
    if (entityId) {
      url = `${url}&entityId=${entityId}`
    }
    return this._httpHandlerService.post(url, formData);
  }

  public uploadProfilePic(formData: any, uID: string) {
    return this._httpHandlerService.put(`onboarding/users/upload-profile-pic?userId=${uID}`, formData)
  }

  updateProfile(payload: any) {
    return this._httpHandlerService.put(`onboarding/users/update-profile`, payload)
  }

  public getOrganizationsSubBrandsById(id: any) {
    return this._httpHandlerService.get(`onboarding/query/business-unit?tenantId=${id}`);
  }

  public getMsspListById(id: any) {
    return this._httpHandlerService.get(`onboarding/query/company/mssp?msspId=${id}`);
  }

  getCompanySummary(tenantId: string): Observable<any> {
    return this._httpHandlerService.get(`onboarding/query/company/${tenantId}`)
  }
}
